var _mask, _rect, _mask2, _rect2, _mask3, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeOverTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_7386_167700",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 4,
    height: 10,
    rx: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 4,
    height: 10,
    rx: 0.5,
    stroke: "#8C8C8C",
    strokeWidth: 2,
    mask: "url(#path-1-inside-1_7386_167700)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_7386_167700",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 4,
    height: 9,
    rx: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 4,
    height: 9,
    rx: 0.5,
    stroke: "#8C8C8C",
    strokeWidth: 2,
    mask: "url(#path-2-inside-2_7386_167700)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_7386_167700",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 3,
    width: 4,
    height: 9,
    rx: 0.5
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 3,
    width: 4,
    height: 9,
    rx: 0.5,
    stroke: "#8C8C8C",
    strokeWidth: 2,
    mask: "url(#path-3-inside-3_7386_167700)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeOverTime);
export default __webpack_public_path__ + "static/media/change-over-time.5c631935.svg";
export { ForwardRef as ReactComponent };